import BlobImage from 'components/blobImage';
import config from 'config';
import { Box, Copy, Modal, SystemText } from '@salesperformanceint/e4shared';
import React from 'react';
import { useSelector } from 'react-redux';
import { apiGet } from 'services';
import Question from 'views/knowledgeBank/components/question';

export const Resources = ({ history, text, resources }) => {
    const [show, setShow] = React.useState(false);
    const [showQuestion, setShowQuestion] = React.useState(false);
    const [question, setQuestion] = React.useState(null);

    const { user } = useSelector(state => state.user);

    const onClick = data => {
        if (data.type === 'question') {
            setShowQuestion(true);
            apiGet(`question-bank/question/${data.id}`, user.guid, response => setQuestion(response));
        } else if (data.extras1) {
            // URL
            window.open(data.extras1);
        } else if (data.extras4) {
            // File
            window.open(`${config.storage.URL}${data.extras4}`);
        } else if (data.extras2) {
            // Text
            setShow(data);
        }
    };

    if (resources?.length === 0) {
        return (
            <div className="no-results">
                <Copy value={text.noResults.resources} />
            </div>
        );
    }

    const closeQuestion = () => {
        setShowQuestion(false);
        setQuestion(null);
    };

    return (
        <div>
            {resources.map(data => {
                return (
                    <Box key={`resource-${data.id}`} className="resource-box pointer" onClick={() => onClick(data)}>
                        <div className="flex flex-row">
                            <div className="image-holder hidden-xs">
                                {data.type === 'question' ? (
                                    <img src="/dist/img/test.jpg" alt="" loading="lazy" />
                                ) : data.image ? (
                                    <BlobImage folder="richardson-thumb" src={data.image} alt="" partnerId="1" />
                                ) : (
                                    <img src="/dist/img/accelerate-icon.png" alt="" loading="lazy" />
                                )}
                            </div>
                            <div className="flex-grow flex flex-column">
                                <div className="flex flex-row">
                                    <button
                                        data-testid="btn-explore-content"
                                        className="btn btn-link flex-grow"
                                        onClick={() => onClick(data)}
                                    >
                                        {data.name}
                                    </button>
                                    {data.type === 'question' ? (
                                        <i className="fa fa-university ml10" />
                                    ) : data.extras2 ? (
                                        <i className="fa fa-lightbulb fa-solid ml10" />
                                    ) : (
                                        <i className="fa fa-external-link" title="Opens in a new window" />
                                    )}
                                </div>
                                {data.type === 'question' ? (
                                    <div className="" style={{ marginTop: 'auto' }}>
                                        {SystemText('PerformanceExplorer/Card/Answers', data.extras1)}
                                    </div>
                                ) : (
                                    <div className="description">{data.summary}</div>
                                )}
                            </div>
                        </div>
                    </Box>
                );
            })}
            <Modal className="explorer-modal" show={show} close={() => setShow(null)} title={show?.name} footer={null}>
                <Copy value={show?.extras2} />
            </Modal>
            <Question show={showQuestion} question={question} onClose={closeQuestion} />
        </div>
    );
};

export default Resources;
